import { IoMdInformationCircle, IoMdInformationCircleOutline } from "react-icons/io";
import { MdEdit } from "react-icons/md";
import Typography from "../../../../componentsNew/Typography";
import { CardDash } from "../CardDash";
import { useEffect, useState } from "@wordpress/element";
import Button from "../../../../componentsNew/Button";
import { SearchPorPalavraChave } from "../SearchPorPalavraChave";
import ItemTable from "../../../../componentsNew/Table/ItemTable";
import { ProgressBarIconNota } from "../ProgressBarIconNota";
import ModalDetalhamentoArtigo from "../ModalDetalhamentoArtigo";
import SemDadosAnalise from "../../../DicasOtimizacao/AnalisesTextuais/Components/SemDadosAnalise";
import HeaderTable from "../../../../componentsNew/Table/HeaderTable";
import TooltipBase from "../../../../componentsNew/Analises/TooltipBase";
import { useGetMetrics } from "@pages/Dashboard/customHooks";
import Pagination from '@componentsNew/Pagination';
import CircularProgress from "@componentsNew/CircularProgress";
import { useContext } from '@wordpress/element';
import ContextSearch from '@pages/Dashboard/ContextSearch';

export function VisaoGeralArtigos({ artigoIds, postLength }) {
    const [isLoading, setIsLoading] = useState([])
    const [metricasFiltradas, setMetricasFiltradas] = useState([]);
    const [metricasPaginadas, setMetricasPaginadas] = useState([]);
    const [open, setOpen] = useState(false)
    const [idArtigoSelecionado, setIdArtigoSelecionado] = useState(0)
    const [qtdeArtigos, setQtdeArtigos] = useState(0);
    const { dataPlanoUsuario } = useContext(ContextSearch)
    
    const redirectToEditPost = async (postId) => {
        const link = window.location.href
        const domain = new URL(link).origin
        window.location.href = `${domain}/wp-admin/post.php?post=${postId}&action=edit`
    }

    useEffect(() => {
        if (artigoIds !== undefined && artigoIds.length > 0) {
            useGetMetrics(artigoIds, setMetricasPaginadas, setMetricasFiltradas, setIsLoading);
        }
    }, [artigoIds])

    const openModal = (id) => {
        setIdArtigoSelecionado(id);
        setOpen(true);
    }

    return (
        <CardDash titulo="Visão Geral dos Artigos" className=" mt-6"
            componenteTitulo={
                <Typography component="base" className="text-text-primary ml-4">
                    <span className="font-bold text-th3">{postLength}</span>
                    <span className="font-normal text-th4">/{dataPlanoUsuario?.data?.quantidadeArtigos}</span>
                    <span className="font-light text-tbody2 ml-2">artigos adicionados</span>
                </Typography>
            }
            componenteLateral={
                <div className="flex items-center content-center w-4/6">
                    <div className="w-full">
                        <SearchPorPalavraChave metricasPaginadas={metricasPaginadas?.metricas} setMetricasFiltradas={setMetricasFiltradas} setQtdeArtigos={setQtdeArtigos} />
                    </div>
                    <Button
                        className="min-w-48 ml-4"
                        disabled={postLength >= dataPlanoUsuario?.data?.quantidadeArtigos}
                        onClick={() => {
                            const domain = window.location.origin
                            window.location.href = `${domain}/wp-admin/admin.php?page=optimarketing&add=true`
                        }}>Adicionar Artigo</Button>
                </div>
            }>
            <div className="overflow-auto mt-6">
                <table className="w-full table-auto flex flex-col divide-y divide-fundo-borda-grafico text-left">
                    <thead className="pb-6">
                        <tr className="flex w-full bg-neutras-grey-light rounded-lg py-2 px-6 gap-4">
                            <HeaderTable className="w-3/12" >TÍTULO DO ARTIGO</HeaderTable>
                            <HeaderTable className="w-2/12">PALAVRA-CHAVE</HeaderTable>
                            <HeaderTable className="w-2/12">NOTA SEO</HeaderTable>
                            <HeaderTable className="w-2/12">NOTA DE LEGIBILIDADE</HeaderTable>
                            <HeaderTable className="w-2/12">
                                <div className="flex flex-wrap">
                                    POSICIONAMENTO
                                    <TooltipBase
                                        posicao="baixo"
                                        texto="As posições na SERP das palavras chaves são enumeradas de 1ª  a 30ª posição, e as demais palavras chaves a partir da 31ª primeira posição serão classificadas em 31ª+"
                                        item={<IoMdInformationCircleOutline className="ml-1 w-5 h-5 relative" />} />
                                </div>
                            </HeaderTable>
                            <HeaderTable className="w-1/12">AÇÕES</HeaderTable>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-fundo-borda-grafico w-full">
                        {metricasFiltradas.length > 0 ? metricasFiltradas?.map(m =>
                            <tr key={m.id} className="flex w-full px-6 py-[0.625rem]">
                                <ItemTable tamanho="3/12" className="pr-4"><span className="truncate">{m?.titulo}</span></ItemTable>
                                <ItemTable tamanho="2/12" className="pr-4">
                                    {m?.palavra ?
                                        <div className="p-2 text-neutras-white bg-grey text-tbody2 rounded-full">
                                            {m?.palavra}
                                        </div>
                                        : <span className="text-error-main font-bold">Sem palavras-chave</span>}
                                </ItemTable>
                                <ItemTable tamanho="2/12" className="pr-4">
                                    <ProgressBarIconNota nota={m?.seo} mudanca={m?.diferencaSEO} />
                                </ItemTable>
                                <ItemTable tamanho="2/12" className="pr-4">
                                    <ProgressBarIconNota nota={m?.legibilidade} mudanca={m?.diferencaLegibilidade} />
                                </ItemTable>
                                <ItemTable tamanho="2/12" className="pr-4">
                                    {(m?.posicao != 0 && m?.posicao != null) && `Top ${m?.mediaPosicao == 31 ? "30+" : m?.mediaPosicao}`}
                                </ItemTable>
                                <ItemTable tamanho="1/12" className="gap-4">
                                    <IoMdInformationCircle className="w-6 h-6 relative text-info-main cursor-pointer" onClick={() => openModal(m?.idArtigo)} />
                                    <MdEdit className="w-6 h-6 relative cursor-pointer" onClick={() => redirectToEditPost(m?.idArtigoWp)} />
                                </ItemTable>
                            </tr>)
                            : <tr className="min-h-[15.438em] items-center justify-center flex h-full">
                                {isLoading ? (
                                    <td className="min-h-[15.438em] justify-center items-center w-full h-full flex">
                                        <CircularProgress component="" size={64} />
                                    </td>) :
                                    <td>
                                        <SemDadosAnalise texto="Selecione 5 artigos para análise e avaliação dos mesmos." />
                                    </td>
                                }
                            </tr>
                        }

                    </tbody>
                </table>
                <Pagination
                    totalPaginas={Math.ceil(metricasPaginadas?.totalDeRegistros / metricasPaginadas?.tamanhoDaPagina) || 0}
                    paginaAtual={metricasPaginadas?.paginaAtual || 0}
                    onPageChange={
                        (page) => useGetMetrics(metricasPaginadas?.artigoIds, setMetricasPaginadas, setMetricasFiltradas, setIsLoading, page, metricasPaginadas?.tamanhoDaPagina)
                    }
                />
            </div>
            <ModalDetalhamentoArtigo open={open} setOpen={setOpen} idArtigo={idArtigoSelecionado} />
        </CardDash>
    )
}
